(function(){
  const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  const fmt = new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur });
  const money = v => { const s = fmt.format(v); return Math.abs(v - Math.round(v)) < 1e-9 ? s.replace(/[.,]00(?=\D*$)/, '') : s; };
  const perDay = v => { const p = v / 30; return p < 1 && cur === 'GBP' ? Math.round(p * 100) + 'p a day' : money(Math.round(p * 100) / 100) + ' a day'; };
  const toast = msg => { const t = document.getElementById('toast'); if (!t) return; t.textContent = msg; t.classList.add('show'); setTimeout(() => t.classList.remove('show'), 2400); };

  document.querySelectorAll('.buy').forEach(box => {
    const tiles = [...box.querySelectorAll('.tile')];
    const st = document.getElementById('sticky');
    function render(){
      const sub = box.dataset.plan === 'sub';
      box.querySelectorAll('[data-plan]').forEach(b => { if (b.tagName === 'BUTTON') b.classList.toggle('on', b.dataset.plan === box.dataset.plan); });
      let sel = tiles.find(t => t.classList.contains('on')) || tiles[0];
      tiles.forEach(t => {
        const p = +t.dataset.p, w = +t.dataset.w, price = sub ? Math.round(p * (100 - (+t.dataset.pct || 0))) / 100 : p;
        t._price = price;
        const ref = w || (sub ? p : 0);
        t.querySelector('.now').textContent = money(price);
        t.querySelector('.was').textContent = ref ? money(ref) : '';
        let pd = t.querySelector('.pd'); if (!pd) { pd = document.createElement('span'); pd.className = 'pd'; t.querySelector('.pr').appendChild(pd); }
        const kids = +(t.dataset.t.match(/^(\d) children/) || [0, 1])[1];
        pd.textContent = perDay(price / kids) + (kids > 1 ? ' per child' : '');
        const s = t.querySelector('.save');
        if (w) { s.textContent = 'Save ' + money(w - price); s.classList.add('show'); } else s.classList.remove('show');
      });
      box.querySelector('.ctap').textContent = money(sel._price);
      box.querySelector('.ctas').textContent = sub ? 'Every 30 days. Skip, pause or cancel any time' : 'One-time payment';
      if (st) { st.querySelector('.stp').textContent = money(sel._price) + (sub ? ' a month' : ''); st.querySelector('.stt').textContent = sel.dataset.t; }
    }
    box.querySelectorAll('button[data-plan]').forEach(b => b.addEventListener('click', () => { box.dataset.plan = b.dataset.plan; render(); }));
    tiles.forEach(t => t.addEventListener('click', e => { e.preventDefault(); tiles.forEach(x => x.classList.remove('on')); t.classList.add('on'); render(); }));
    const add = () => {
      const t = tiles.find(x => x.classList.contains('on')) || tiles[0];
      const item = { id: +t.dataset.v, quantity: +t.dataset.q || 1 };
      if (box.dataset.plan === 'sub' && t.dataset.sp) item.selling_plan = +t.dataset.sp;
      const btns = [box.querySelector('.cta'), st && st.querySelector('button')].filter(Boolean);
      btns.forEach(b => b.disabled = true);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(r => r.json().then(j => { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag'); }))
        .then(() => { window.location.href = t.dataset.code ? '/discount/' + encodeURIComponent(t.dataset.code) + '?redirect=%2Fcart' : '/cart'; })
        .catch(e => { btns.forEach(b => b.disabled = false); toast(e.message); });
    };
    box.querySelector('.cta').addEventListener('click', add);
    if (st) {
      st.querySelector('button').addEventListener('click', add);
      const cta = box.querySelector('.cta');
      new IntersectionObserver(es => es.forEach(e => st.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0))).observe(cta);
    }
    render();
  });

  document.querySelectorAll('.nav a').forEach(a => a.addEventListener('click', () => document.body.classList.remove('yp-open')));
  // live ETA: 3 working days out, recalculated per visit
  (function(){ const d = new Date(); let n = 0; while (n < 3) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n++; }
    const txt = d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
    document.querySelectorAll('.eta').forEach(e => e.textContent = txt); })();
  document.querySelectorAll('.swap').forEach(b => b.addEventListener('click', () => {
    const t = document.querySelectorAll('.buy .tile')[1]; if (!t) return; t.click(); t.scrollIntoView({ behavior: 'smooth', block: 'center' }); }));
  document.querySelectorAll('.gal').forEach(g => {
    const tr = g.querySelector('.track'), dots = [...g.querySelectorAll('.dots button')];
    dots.forEach((d, i) => d.addEventListener('click', () => tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' })));
    tr.addEventListener('scroll', () => { const i = Math.round(tr.scrollLeft / tr.clientWidth); dots.forEach((d, j) => d.classList.toggle('on', i === j)); });
  });
})();
